export var loadedStyle = []

/**
 * 加载样式
 * @param { string<href> } href
 * @returns promise
 */
export function loadStyle(href) {
  return new Promise(resolve => {
    if (loadedStyle.includes(href)) {
      resolve({
        code: 1,
        msg: 'this style was loaded'
      })
    }
    const styleEl = document.createElement('link')
    styleEl.setAttribute('rel', 'stylesheet')
    styleEl.setAttribute('href', href)
    document.head.appendChild(styleEl)

    styleEl.onload = function() {
      loadedStyle.push(href)
      resolve({
        code: 1,
        msg: 'style load success!'
      })
    }
  })
}



// WEBPACK FOOTER //
// ./src/frontend-lib/tools/loadStyle.js